export default "__VITE_ASSET__BRum7UNK__"